import React, { FC } from 'react';
import { Button } from '@src/components/Button';
import { Status } from './Status';
import { OpeningActionsButtonsProps } from './props';
import './styles.scss';

export const OpeningActionsButtons: FC<OpeningActionsButtonsProps> = ({ openingState, actions, onAction }) => {
  const hasOnlyIcon = ['pause'];

  return (
    <div className="opening-header-actions">
      <Status state={openingState} />

      {actions.map(item => (
        <Button
          appearance={item.appearance}
          icon={item.icon}
          isCircle={hasOnlyIcon.includes(item.key)}
          isDisabled={item.disabled}
          key={item.key}
          onClick={() => onAction(item)}
        >
          {!hasOnlyIcon.includes(item.key) && item.label}
        </Button>
      ))}
    </div>
  );
};
